// Hero Carousel Functionality
(function() {
  if (!document.querySelector('[data-hero-carousel]')) return;

  var carousel = document.querySelector('[data-hero-carousel]');
  var slides = carousel.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.carousel-dot');
  var prevBtn = document.querySelector('.side-nav-btn--prev');
  var nextBtn = document.querySelector('.side-nav-btn--next');

  var currentSlide = 0;
  var totalSlides = slides.length;
  var autoplayInterval;

  function goToSlide(index) {
    // Remove active class from all
    slides.forEach(function(slide) {
      slide.classList.remove('is-active');
      slide.setAttribute('aria-hidden', 'true');
    });
    dots.forEach(function(dot) { dot.classList.remove('is-active'); });

    // Add active class to current
    slides[index].classList.add('is-active');
    slides[index].setAttribute('aria-hidden', 'false');
    if (dots[index]) dots[index].classList.add('is-active');

    currentSlide = index;
  }

  function nextSlide() {
    var next = (currentSlide + 1) % totalSlides;
    goToSlide(next);
  }

  function prevSlide() {
    var prev = (currentSlide - 1 + totalSlides) % totalSlides;
    goToSlide(prev);
  }

  // Autoplay (5 seconds)
  function startAutoplay() {
    autoplayInterval = setInterval(nextSlide, 5000);
  }

  function stopAutoplay() {
    clearInterval(autoplayInterval);
  }

  // Event listeners
  if (nextBtn) nextBtn.addEventListener('click', function() {
    nextSlide();
    stopAutoplay();
    startAutoplay();
  });

  if (prevBtn) prevBtn.addEventListener('click', function() {
    prevSlide();
    stopAutoplay();
    startAutoplay();
  });

  dots.forEach(function(dot, index) {
    dot.addEventListener('click', function() {
      goToSlide(index);
      stopAutoplay();
      startAutoplay();
    });
  });

  // Start autoplay (respect reduced motion preference)
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (totalSlides > 1 && !prefersReducedMotion) {
    startAutoplay();
  }

  // Pause on hover
  carousel.addEventListener('mouseenter', stopAutoplay);
  carousel.addEventListener('mouseleave', function() {
    if (totalSlides > 1) startAutoplay();
  });

  // Force Video Playback Legacy Fallback
  function forcePlayVideos() {
    document.querySelectorAll('.god-hero__video').forEach(function(video) {
      if (video.tagName === 'VIDEO') {
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');
        video.muted = true;
        video.play().catch(function() { /* Autoplay handled by browser interaction */ });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', forcePlayVideos);
  document.addEventListener('touchstart', forcePlayVideos, {once: true});
  document.addEventListener('click', forcePlayVideos, {once: true});
})();

// Strip controls attribute from hero videos as extra safety + fallback image on error
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.god-hero__video').forEach(function(v) {
    if (v.tagName === 'VIDEO') {
      v.removeAttribute('controls');
      v.setAttribute('playsinline', '');
      v.muted = true;
      // Fallback: if video fails to load, show the background image
      v.addEventListener('error', function() {
        v.style.display = 'none';
        var fallback = v.closest('.god-hero__bg').querySelector('.god-hero__fallback');
        if (fallback) fallback.style.display = 'block';
      });
      // Also handle stalled/suspended video
      v.addEventListener('stalled', function() {
        var fallback = v.closest('.god-hero__bg').querySelector('.god-hero__fallback');
        if (fallback) fallback.style.opacity = '1';
      });
    }
  });
});
